import React from 'react';

export default function Security() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[var(--color-primary)] mb-8">Güvenlik</h1>
      <p className="text-[var(--color-black)]">Güvenlik ile ilgili bilgiler burada yer alacak.</p>
    </div>
  );
} 